import React from 'react';

export interface TechniqueInfo {
  name: string;
  count: number;
}

export interface TechniqueCardProps {
  technique?: TechniqueInfo | null;
  isEmpty?: boolean;
  emptyMessage?: string;
  className?: string;
}

const TechniqueCard: React.FC<TechniqueCardProps> = ({
  technique,
  isEmpty = false,
  emptyMessage = "Tag techniques on your trainings notes to discover which you apply more!",
  className = ""
}) => {
  if (isEmpty || !technique) {
    return (
      <div className={`flex flex-col items-center ${className}`}>
        {/* Zero Data State */}
        <div className="text-[24px] font-bold text-white mb-2">0</div>
        <p className="text-[10px] text-white text-center">
          {emptyMessage}
        </p>
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center ${className}`}>
      {/* Filled State - Technique Info */}
      <div className="text-[24px] font-bold text-white mb-2">{technique.count}</div>
      <div className="flex px-2 py-1 bg-[#D72E16] rounded-full">
        <span className="text-white text-[8px] font-medium">{technique.name}</span>
      </div>
    </div>
  );
};

export default TechniqueCard;
